const languagify = (language) => {
  if (window.lang === 1) {
    switch (language) {
      case 'Race':
        return 'La race';
      case 'Gender':
        return 'Le genre';
      case 'Job Role':
        return 'Le rôle de l\'emploi';
      case 'white:':
        return 'Blanc:';
      case 'White':
        return 'Blanc';
      case 'black:':
        return 'Noir:';
      case 'Black':
        return 'Noir';
      case 'asian:':
        return 'Asiatique:';
      case 'Asian':
        return 'Asiatique';
      case 'indigenous:':
        return 'Indigène:';
      case 'Indigenous':
        return 'Indigène';
      case 'mixed-race:':
        return 'Race mixte:';
      case 'Mixed Race':
        return 'Race mixte';
      case 'middle-eastern:':
        return 'Moyen-Oriental:';
      case 'Middle Eastern':
        return 'Moyen-Oriental';
      case 'M. Eastern':
        return 'Moy. Oriental';
      case 'M.Eas':
        return 'M.Orien.';
      case 'Unk.':
        return 'Inco.';
      case 'Unknown':
        return 'Inco.';
      case 'latin:':
        return 'Latin:';
      case 'Latin':
        return 'Latin';
      case 'men:':
        return 'Hommes:';
      case 'Men':
        return 'Hommes';
      case 'women:':
        return 'Femmes:';
      case 'Women':
        return 'Femmes';
      case 'non-binary:':
        return 'Non Binaires:';
      case 'Non-Binary':
        return 'Non Binaires';
      case 'Non-Bin':
        return 'Non Bin';
      case 'full-time:':
        return 'À plein temps:';
      case 'Full-time':
        return 'À plein temps';
      case 'Full-Time':
        return 'À plein temps';
      case 'supervisor:':
        return 'Superviseurs:';
      case 'Supervisor':
        return 'Superviseur';
      case 'Supervisors':
        return 'Superviseurs';
      case 'part-time:':
        return 'À temps partiel:';
      case 'Part-time':
        return 'À temps partiel';
      case 'Part-Time':
        return 'À temps partiel';
      case 'interns:':
        return 'Stagiaires:';
      case 'Interns':
        return 'Stagiaires';
      case 'More Men':
        return 'Plus d\'hommes';
      case 'More White vs. Audience *  ':
        return 'Plus de Blanc vs Audience *  ';
      case 'More Women':
        return 'Plus de femmes';
      case 'More Vis. Min. or Indig. vs. Audience *  ':
        return 'Plus de minorités visibles ou d\'autochtones par rapport à l\'audience * ';
      case 'More Visible Minority or Indigenous vs. Audience *  ':
        return 'Plus de minorités visibles ou d\'autochtones par rapport à l\'audience * ';
      case 'Average':
        return 'Moyenne';
      case 'pts over-represented white':
        return 'pts blanc surreprésenté';
      case 'Parity with':
        return 'Parité avec';
      case 'Audience':
        return 'l\'audience';
      case 'MY NEWSROOM *':
        return 'SALLE DE PRESSE *';
      case 'SUPERVISORS. More Vis. Min. and/or Indig. ⟶':
        return 'SUPERVISEURS. Plus de minorités visibles et/ou d\'autochtones ⟶';
      case 'SUPERVISORS. More Women ⟶':
        return 'SUPERVISEURS. Plus de femmes ⟶';
      case 'STAFF MEMBERS. More Vis. Min. and/or Indig. ⟶':
        return 'MEMBRES DU PERSONNEL. Plus de minorités visibles et/ou d\'autochtones ⟶';
      case 'STAFF MEMBERS. More Women ⟶':
        return 'MEMBRES DU PERSONNEL. Plus de femmes ⟶';
      case 'OF NEWSROOMS HAVE':
        return 'DES SALLES DE PRESS ONT';
      case 'IN A TOP LEADERSHIP ROLE':
        return 'DANS UN RÔLE DE LEADERSHIP SUPÉRIEUR';
      case 'Full-time (No Supervisors)':
        return 'À plein temps (Pas de superviseurs)';
      case 'English':
        return 'Anglais';
      case 'French':
        return 'Français';
      case 'Filter by:':
        return 'Filtrer par:';
      case 'Selected':
        return 'Sélectionnés';
      case 'No Vis. Min or Indig.':
        return '0 minorité vis. ou autochtone';
      case '1 Vis. Min or Indig.':
        return '1 minorité vis. ou autochtone';
      case '+1 Vis. Min or Indig.':
        return '+1 minorité vis. ou autochtone';
      case 'Census':
        return 'Recensement';
      case 'All Staff':
        return 'Tout le personnel';
      case 'Canadian Newsroom Diversity Survey':
        return 'Sondage sur la diversité dans les salles de presse canadiennes';
      case 'Select Criteria:':
        return 'Sélectionnez les critères:';
      case '2021 Survey':
        return 'Sondage 2021';
      case '2022 Survey':
        return 'Sondage 2022';
      case 'Data Comparison':
        return 'Comparaison des données';
      case 'Filter By:':
        return 'Filter Par:';
      case '# of Journalist':
        return '# de Journalistes';
      case '# of Media Outlets':
        return '# de Salles de presse';
      case '# of Men':
        return '# d\'hommes';
      case '# of Women':
        return '# de femmes';
      case '# of Non-Binary':
        return '# de Non Binaires';
      case '# of Supervisors':
        return '# de Superviseurs';
      case '# of Full-time':
        return 'A plein temps';
      case '# of Part-time':
        return 'A temps partiel';
      case '# of Interns':
        return '# de Stagiaires';
      case '# of Indigenous':
        return '# d\'indigènes';
      case '# of Asian':
        return '# d\'asiatiques';
      case '# of Black':
        return '# de noirs';
      case '# of Latin':
        return '# de latins';
      case '# of Middle Eastern':
        return '# de Moyen-oriental';
      case '# of White':
        return '# de blancs';
      case '# of Mixed Race':
        return 'Race mixte';
      case '# of Unknown':
        return 'Inconnue';
      case '2023 Survey':
        return 'Sondage 2023';
      case 'https://caj.ca/wp-content/uploads/Canadian-Newsroom-Diversity-Survey-2022.pdf':
        return 'https://caj.ca/wp-content/uploads/Canadian-Newsroom-Diversity-Survey-2022_FR.pdf';
      case 'https://caj.ca/wp-content/uploads/Diversity_Survey_Report_2023_EN.pdf':
        return 'https://caj.ca/wp-content/uploads/Diversity_Survey_Report_2023_FR.pdf';
      case 'The Canadian Association of Journalists’ second annual diversity survey includes data from 5,012 journalists working in 242 newsrooms nationwide. It is Canada’s largest survey of the race and gender of those who work in media. Data analysis and interactives were produced by Pennsylvania-based firm Qlik.':
        return 'Le deuxième sondage annuel sur la diversité de l\'Association canadienne des journalistes comprend des données provenant de 5 012 journalistes travaillant dans 242 salles de rédaction à l\'échelle nationale. Il s\'agit de la plus grande enquête au Canada sur la race et le genre des personnes qui travaillent dans les médias. L\'analyse des données et les éléments interactifs ont été produits par la société Qlik, basée en Pennsylvanie.';
      case 'The Canadian Association of Journalists’ third annual diversity survey includes data from 6,035 journalists working in 273 newsrooms nationwide. It is Canada’s largest survey of the race and gender of those who work in media. Data analysis and interactives were produced by Pennsylvania-based firm Qlik.':
        return 'Le troisième sondage annuel sur la diversité de l\'Association canadienne des journalistes comprend des données provenant de 6 035 journalistes travaillant dans 273 salles de rédaction à l\'échelle nationale. Il s\'agit de la plus grande enquête au Canada sur la race et le genre des personnes qui travaillent dans les médias. L\'analyse des données et les éléments interactifs ont été produits par la société Qlik, basée en Pennsylvanie.';
      default:
        return language;
    }
  } else {
    return language;
  }
};
export default languagify;
